export const PLAYER_CONTAINER_CLASS = 'react-all-player-container';
